<template>
  <div class="webgl-legend white">
    <ul>
      <li>
        <div class="indicator border-1" :style="style('holes')" />
        {{ $t('npth') }}
      </li>
      <li>
        <div class="indicator border-1" :style="style('millinglv1')" />
        {{ $t('milling') }}
      </li>
      <li>
        <div class="indicator border-1" :style="style('board')" />
        {{ $t('base_material') }}
      </li>
    </ul>
  </div>
</template>

<script>
import * as PcbMaterials from 'helper/pcb_materials';
import { components } from 'locales';

export default {
  name: 'BoardInspectorLegend',
  props: {
    materialPreset: String,
  },
  computed: {
    materialColors() {
      return PcbMaterials[this.materialPreset];
    },
  },
  methods: {
    style(material) {
      return {
        'background-color': this.materialColors[material].color.getStyle(),
      };
    },
  },
  i18n: components.BoardInspectorLegend,
};
</script>

<style scoped lang="scss">
.border-1 {
  border: 1px solid white;
}

.webgl-legend {
  background-color: #2E3440dd;
  border-radius: 12px;
  display: flex;
}
</style>
